import { Reference } from 'common/reference/reference.js';
import { SponsorAppend2Module } from 'common/sponsor-append-module.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { SummaryItem } from 'components.modules.gen/category-summary/item.js';
import { IModule } from 'redux-state/layout/types.js';
import { hasObjectsHaveProps } from 'utilities/helpers/object.scaffold.js';
import { setDefaultTitle } from 'utilities/text/titleDefault.js';
import { IntegrationsConfigWrapper } from '../general/types.js';
import { DryingIndex } from './dryingIndex.js';
import { MainSort } from './main-sort.js';
import { Pollen } from './pollen.js';
import { IntegrationsCore } from './types.js';
import { UVContent } from './uv.js';

export type SortOrder = {
  displayOrder?: number;
};

export const IntegrationsModule = (props: IModule<IntegrationsConfigWrapper<IntegrationsCore>>) => {
  const { pollen, uv, dryingIndex, items, mainSponsor } = props.config;
  const displayModule = hasObjectsHaveProps(pollen, uv, dryingIndex, mainSponsor);
  if (displayModule) {
    return (
      <Tile dataModule="integrations" classes="Integrations" config={props.config}>
        <div className="Tile-body IconWithText--container">
          <TileBodyHeaderV2
            config={setDefaultTitle(props.config, 'Partnerships')}
            modulePath={props.modulePath}
            classes="u-mB-responsive u-mB-md"
          />
          <MainSort sortOrder={[uv?.displayOrder, pollen?.displayOrder, dryingIndex?.displayOrder]}>
            <UVContent key="uv" uvData={uv} />
            <Pollen key="pollen" pollen={pollen} />
            <DryingIndex key="dryingIndex" dryingIndex={dryingIndex} />
            {(items ?? []).map((item, index) => (
              <SummaryItem {...item} key={`${item.title ?? index}`}>
                <Reference classes="u-mT-xs u-mB-xs" {...item.sponsor} />
              </SummaryItem>
            ))}
          </MainSort>
        </div>
        <SponsorAppend2Module image={mainSponsor?.sponsorImage} url={mainSponsor?.sponsorURL} />
      </Tile>
    );
  }

  return null;
};
